import { render, staticRenderFns } from "./FleshRight.vue?vue&type=template&id=3c028992&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c028992')) {
      api.createRecord('3c028992', component.options)
    } else {
      api.reload('3c028992', component.options)
    }
    module.hot.accept("./FleshRight.vue?vue&type=template&id=3c028992&", function () {
      api.rerender('3c028992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/FleshRight.vue"
export default component.exports